import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {filter, first, switchMap} from "rxjs/operators";
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {HostingToolsComponent} from "./hosting-tools.component";
import {combineLatest} from "rxjs";

@Injectable()
export class HostingToolsResolver implements Resolve<HostingToolsComponent | null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const website = route.parent.parent.data['website'];

    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getHostingSettingsLoaded(website.isNetwork && !website.parentId && website.children && website.children.length ? website.children[0] : website.id))
        .pipe(
          filter((loaded: boolean) => !!loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getCacheExclude(website.isNetwork && !website.parentId && website.children && website.children.length ? website.children[0] : website.id)),
            this._store.select(fromStore.getHostingSettings(website.isNetwork && !website.parentId && website.children && website.children.length ? website.children[0] : website.id)),
            )
          ),
          first()
        )
        .subscribe(([cacheExclude, settings]) => {
          if (settings) {
            resolve(settings);
          } else {
            resolve(null);
          }
        });
    });
  }
}
